import { Component } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { SearchComponent } from '../../../shared/search/search.component';
import { EDevices, ResponsiveService } from '../../../shared/services/responsive.service';
import { Destroy } from '../../../core/destroyClass';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [
    LottieComponent,
    SearchComponent
  ],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent extends Destroy {
  protected EDevices = EDevices;

  lottieOptions: AnimationOptions = {
    path: '/assets/animations/welcome.json',
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  currentDevice: EDevices;

  constructor(
    private responsiveService: ResponsiveService,
  ) {
    super();
  }

  ngOnInit() {
    this.currentDevice = this.responsiveService.getDevice();
    this.responsiveService.device$
      .pipe(takeUntil(this.destroy$))
      .subscribe((device) => (this.currentDevice = device));
  }
}
